var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("车辆注册省")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }